import { useEffect, useRef, useState } from 'react';
import { isNumber } from 'lodash';

export const useCallDisposable = ({ isDisposable, timeout }) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const timeoutRef = useRef();

  useEffect(() => () => isNumber(timeoutRef.current) && clearTimeout(timeoutRef.current), []);

  return {
    callDisposable() {
      if (isDisabled) return;

      if (isDisposable) setIsDisabled(true);

      if (isNumber(timeout)) {
        setIsDisabled(true);

        timeoutRef.current = setTimeout(() => {
          setIsDisabled(false);
          timeoutRef.current = null;
        }, timeout);
      }

      return true;
    },
  };
};
